import styled from 'styled-components';
import { IconWrapper } from '@mlb/react-patterns/components/AccordionItem/AccordionItem.style';

export const BoxscoreTeamCollapsibleWrapper = styled.div`
    padding-left: 6px;
`;

export const BoxscoreIconWrapper = styled(IconWrapper)`
    position: absolute;
    right:6px;
    z-index:1;
`;

export const ContentTitleWrapper = styled.span`
    font-family: var(--gameday-primary-font);
    font-size: 12px;
    text-transform: lowercase;
    font-weight: 700;
    line-height: 12px;
    color: var(--gameday-primary-font-color);
    display:inline-block;
    margin-bottom: 8px;

    &:first-letter {
        text-transform: uppercase;
    }
    padding-top: 16px;

`;

export const VisibleContentWrapper = styled.div.attrs({
    'data-mlb-test': 'gamedayVisibleContentWrapper'
})`

    > div:first-of-type {
        > span {
            padding-top: 0;
        }
    }
    &&& {
        ${ContentTitleWrapper} {
            display:block;
        }
    }
`;

export const ContentWrapper = styled.div`
    font-size: 14px;
    color: var(--gameday-secondary-font-color);
    
    &:first-child {
        ${ContentTitleWrapper} {
            display: none; // hide the first title
        }
    }

`;

export const FieldListWrapper = styled.div.attrs({
    'data-mlb-test': 'gamedayFieldListWrapper'
})`
    font-size: 12px;
    font-weight: normal;
    color: var(--gameday-secondary-font-color);
`;

export const FieldListInnerWrapper = styled.span.attrs({
    'data-mlb-test': 'gamedayFieldListTitleWrapper'
})`
    font-style: normal;
    display: inline-block;
    font-weight: bold;
    color: var(--gameday-primary-font-color);
    line-height: 12px;
    font-size: 12px;
`;

export const FieldListDividerWrapper = styled(FieldListInnerWrapper).attrs({
    'data-mlb-test': 'gamedayFieldListTitleWrapper'
})`
    margin-right: 5px;
`;

export const BoxscoreInfoContainer = styled.div.attrs({
    'data-mlb-test': 'gamedayBoxscoreInfoContainer'
})`
    font-feature-settings: "tnum";
    font-size: 15px;
    font-weight: 700;
    padding-top:6px;
    padding-bottom: 6px;
    font-family: var(--gameday-primary-font);
    line-height: 20px;
    position: relative;
    border-radius: 6px;
    margin-left: -6px;
    margin-top: 12px;

    ${BoxscoreIconWrapper} {
        background-color: transparent;
        border: 1px solid var(--gameday-secondary-font-color);

        svg {
            border: 0;
            path {
                fill: var(--gameday-secondary-font-color);
            }
        }
    }

`;
